import React, { useRef, useState, useLayoutEffect, useCallback } from 'react';
import { Tooltip, Typography } from 'antd';

const { Text } = Typography;

const TruncatedText = ({ children, tooltipTitle, tooltipPlacement = 'top', textProps = {}, ...rest }) => {
  const ref = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setIsTruncated(el.scrollWidth > el.clientWidth);
  }, []);

  useLayoutEffect(() => {
    checkTruncation();

    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;

    const observer = new ResizeObserver(checkTruncation);
    observer.observe(el);
    return () => observer.disconnect();
  }, [checkTruncation, children]);

  const content = (
    <span
      ref={ref}
      style={{
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
      {...rest}
    >
      <Text {...textProps}>{children}</Text>
    </span>
  );

  // Only mount the Tooltip when needed — avoids a listener on every cell
  if (!isTruncated) return content;

  return (
    <Tooltip title={tooltipTitle ?? children} placement={tooltipPlacement}>
      {content}
    </Tooltip>
  );
};

export default TruncatedText;